module.exports = __webpack_public_path__ + "17367562.svg";